// extracted by mini-css-extract-plugin
export default {"backgroundImage":"w6yu0","load":"Lu9eu"};